import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logoo from "../Components/logo/LogoPlusSlogan-removebg-preview.png";

function VolcafeHeader() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="relative z-50">
      {/* White Navbar (Always Visible) */}
      <div
        className={`bg-white text-black w-full transition-all duration-300 border-animation ${
          isScrolled ? "fixed top-0 left-0 shadow-md" : "relative"
        }`}
      >
        <div className="max-w-screen-2xl mx-auto px-8 py-2 flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center transition-all">
            <Link to="/">
              <img
                src={logoo}
                alt="Logo"
                className={isScrolled ? "h-20 w-auto" : "h-36 w-auto"}
              />
            </Link>
          </div>

          {/* Navbar Links - Always Visible */}
          <div className="lg:flex lg:items-center lg:space-x-8 ml-auto">
            <div className="relative flex items-center nav-tab rounded-lg group">
              <Link
                to="/"
                className="font-bold text-base md:text-lg hover:text-gray-700 relative"
              >
                Home
                <span className="absolute left-0 bottom-0 w-0 h-1 bg-green-700 transition-all duration-300 group-hover:w-full"></span>
              </Link>
            </div>
            <div className="relative flex items-center nav-tab rounded-lg group">
              <Link
                to="/locations"
                className="font-bold text-base md:text-lg hover:text-gray-700 relative"
              >
                Locations
                <span className="absolute left-0 bottom-0 w-0 h-1 bg-green-700 transition-all duration-300 group-hover:w-full"></span>
              </Link>
            </div>
            <div className="relative flex items-center nav-tab rounded-lg group">
              <Link
                to="/about-us"
                className="font-bold text-base md:text-lg hover:text-gray-700 relative"
              >
                About Us
                <span className="absolute left-0 bottom-0 w-0 h-1 bg-green-700 transition-all duration-300 group-hover:w-full"></span>
              </Link>
            </div>
            <div className="relative flex items-center nav-tab rounded-lg group">
              <Link
                to="/our-products"
                className="font-bold text-base md:text-lg hover:text-gray-700 relative"
              >
                Our Products
                <span className="absolute left-0 bottom-0 w-0 h-1 bg-green-700 transition-all duration-300 group-hover:w-full"></span>
              </Link>
            </div>
            <div className="relative flex items-center nav-tab rounded-lg group">
              <Link
                to="/contact-us"
                className="font-bold text-base md:text-lg hover:text-gray-700 relative"
              >
                Get In Touch
                <span className="absolute left-0 bottom-0 w-0 h-1 bg-green-700 transition-all duration-300 group-hover:w-full"></span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default VolcafeHeader; 
